<template>
  <b-modal
    ref="ConfigurationIncidentOriginsModal"
    size="xs"
    centered
    modal-class="configuration-incident-origins-form"
    @hidden="hide"
  >
    <div slot="modal-title">
      {{ actionTitle }} <span style="text-transform: lowercase">{{ $tc('configuration.sections.incidentOrigins', 1) }}</span>
    </div>
    <b-row class="pt-2 pb-3 px-3">
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $tc('configuration.sections.incidentOrigins', 1) }}</label>
        </div>
        <ConfigurationNameTranslations :name-translations="internalOrigin.nameTranslations" />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $t('configuration.grid.description') }}</label>
        </div>
        <ConfigurationNameTranslations :name-translations="internalOrigin.descriptionTranslations" />
      </b-col>
    </b-row>
    <b-row class="px-3">
      <b-col>
        <hr>
      </b-col>
    </b-row>
    <b-row class="px-3 mb-2">
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $t('configuration.grid.phase') }}</label>
        </div>
        <vt-combo-select
          v-model="internalOrigin.workPhase"
          :options="workPhases.options"
          label="name"
          :allow-empty="false"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3 d-flex justify-content-end"
      >
        <div class="switch-btn mt-1 p-0 d-flex align-items-center">
          <span
            v-if="internalOrigin.active"
            class="mr-2"
          >{{ $t('configuration.actions.active') }}</span>
          <span
            v-else
            class="mr-2"
          >{{ $t('configuration.actions.inactive') }}</span>
          <input
            id="toggle"
            v-model="internalOrigin.active"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="toggle"
            class="switch mb-0"
          />
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            :disabled="!canEditOrAdd"
            size="sm"
            class="btn--primary"
            @click="update()"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ actionTitle }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import IncidentOriginsConfigurationServices from '@/api/resources/configuration/incidents/origins/IncidentOriginsConfigurationServices'
import ConfigurationNameTranslations from '@/modules/configurationModule/detail/ConfigurationNameTranslations'
import languageService from '@/api/resources/common/languageService'
import { cloneDeep, isEmpty, uniqBy } from 'lodash'

export default {
    name: 'ConfigurationIncidentOriginsModal',
    components: { ConfigurationNameTranslations },
    props: {
        actionTitle: String
    },
    data() {
        return {
            workPhases: {
                options: []
            },
            internalOrigin: {
                nameTranslations: [],
                descriptionTranslations: [],
                workPhase: {}
            }
        }
    },
    computed: {
        canEditOrAdd() {
            const defaultLanguage = this.internalOrigin.nameTranslations.find(name => name.language.defaultLanguage)
            const defaultLanguageDesc = this.internalOrigin.descriptionTranslations.find(name => name.language.defaultLanguage)
            const phaseSelected = !!this.internalOrigin.workPhase.id
            if (defaultLanguage && defaultLanguageDesc) {
                return !!defaultLanguage.value.length && !!defaultLanguageDesc.value.length && phaseSelected
            }
            return false
        }
    },
    mounted() {
        this.getWorkPhases()
    },
    methods: {
        async show(selectedOrigin) {
            this.updateLoading(true)
            const [err, response] = await this.toCall(languageService.findAllActiveAndUiEnabled())
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobalFromErrorResponse(err)
                return
            }
            const activeUILanguages = response
            if (selectedOrigin && !isEmpty(selectedOrigin)) {
                this.internalOrigin = cloneDeep(selectedOrigin)
            } else {
                this.clearData()
            }
            const defaultNameTranslations = activeUILanguages.map(lang => {
                return {
                    language: lang,
                    notes: '',
                    value: ''
                }
            })
            const nameTranslations = [].concat(this.internalOrigin.nameTranslations, cloneDeep(defaultNameTranslations))
            const descriptionTranslations = [].concat(this.internalOrigin.descriptionTranslations, cloneDeep(defaultNameTranslations))
            this.internalOrigin.nameTranslations = uniqBy(nameTranslations, 'language.id')
            this.internalOrigin.descriptionTranslations = uniqBy(descriptionTranslations, 'language.id')
            this.$refs.ConfigurationIncidentOriginsModal.show()
        },
        hide() {
            this.$refs.ConfigurationIncidentOriginsModal.hide()
        },
        update() {
            if (this.internalOrigin.id) {
                this.$emit('update', this.internalOrigin)
            } else {
                this.$emit('create', this.internalOrigin)
            }
        },
        clearData() {
            this.internalOrigin = {
                active: true,
                id: '',
                name: '',
                nameTranslations: [],
                descriptionTranslations: [],
                workPhase: {}
            }
        },
        async getWorkPhases() {
            const [err, response] = await this.toCall(IncidentOriginsConfigurationServices.getWorkPhases())
            if (err) {
                this.showErrorModalGlobalFromErrorResponse(err)
                this.workPhases.options = []
            }
            this.workPhases.options = response
        }
    }
}
</script>

<style lang="scss">
    .configuration-incident-origins-form .translations-area {
        max-height: 100px;
        overflow-y: auto;
        padding-bottom: 3px;
    }
</style>
